/* Happy Ears — product page fixes (28 Aug 2026, rev 3 Sep 2026)
   1. Colour swatches keep a stable order instead of flipping between products.
   2. The chosen size carries across a colour change.
   3. The gallery follows the chosen size — each size has its own featured image.
   4. The SNR figure follows the chosen variant (bundles: Transparent 25, Ocean Plastics 27).
   5. The last breadcrumb follows the product across a colour change.
   6. Mobile colour swatches: 4 across, every colour shown, no "+ more" collapse.

   The theme swaps the product section over AJAX (pushState, no page load), so they
   all re-apply on DOM change. Every operation is idempotent — it only writes when
   the state is actually wrong — so the observer cannot trigger itself in a loop. */
(function () {
  if (window.__hePdpFixes) return;
  window.__hePdpFixes = true;

  var KEY = 'he-size=';
  var timer = null;

  function handleOf(cell) {
    var path = cell.tagName === 'A' ? (cell.getAttribute('href') || '') : window.location.pathname;
    return path.split('?')[0].split('#')[0].replace(/\/$/, '').split('/').pop();
  }

  function reorder() {
    var grid = document.querySelector('.pdp-connected-grid--colors, .pdp-connected-grid--single-color');
    if (!grid) return;
    var cells = [].slice.call(grid.querySelectorAll('.pdp-connected-grid__cell'));
    if (cells.length < 2) return;
    var want = cells.map(function (c) { return { c: c, k: handleOf(c) }; })
                    .sort(function (a, b) { return a.k < b.k ? -1 : a.k > b.k ? 1 : 0; })
                    .map(function (o) { return o.c; });
    var same = want.every(function (c, i) { return cells[i] === c; });
    if (same) return;
    want.forEach(function (c) { grid.appendChild(c); });
  }

  // Match on the option VALUES (Small / Medium / Large), which are deliberately
  // left untranslated, rather than the option NAME — the name is translated per
  // locale (Storlek / Größe / Taille / 사이즈) and a name test silently fails
  // everywhere except English. Known names are kept as a fallback in case a
  // value is ever renamed.
  var SIZE_VALUES = ['small', 'medium', 'large'];
  var SIZE_NAMES = ['size', 'storlek', 'größe', 'grosse', 'taille', 'sizes', '사이즈'];

  function isSizeInput(i) {
    var n = (i.getAttribute('data-option-name') || '').toLowerCase();
    if (n.indexOf('pack') !== -1) return false;           // never the pack-size option
    if (SIZE_VALUES.indexOf(String(i.value).toLowerCase()) !== -1) return true;
    for (var k = 0; k < SIZE_NAMES.length; k++) {
      if (n.indexOf(SIZE_NAMES[k]) !== -1) return true;
    }
    return false;
  }

  function sizeInputs() {
    return [].slice.call(document.querySelectorAll('.VariantSelect input.inputSelectboxCheckbox'))
      .filter(isSizeInput);
  }

  function chosenSize() {
    var hit = sizeInputs().filter(function (i) { return i.checked; })[0];
    return hit ? hit.value : null;
  }

  // ---- the size carries across a colour change -----------------------------
  // The theme swaps the product over AJAX and rewrites the URL to ?variant=…,
  // so there is no page load and no surviving hash on that path — the size has
  // to be carried in a plain variable, set the moment the swatch is clicked.
  // The hash and sessionStorage are the second channel, for the case where the
  // link really does cause a page load (new tab, shared URL, no-JS fallback).
  // pendingUntil bounds it: the size applies to the render that follows the
  // click, not to whatever the visitor browses to five minutes later.
  var pending = null;
  var pendingUntil = 0;

  function arm(value) {
    if (!value) return;
    pending = value;
    pendingUntil = Date.now() + 5000;
  }

  arm((function () {
    var h = window.location.hash || '';
    var i = h.indexOf(KEY);
    var v = null;
    if (i !== -1) v = decodeURIComponent(h.slice(i + KEY.length).split('&')[0]);
    try {
      if (!v) v = sessionStorage.getItem('he-size');
      sessionStorage.removeItem('he-size');   // consumed, so it cannot leak onward
    } catch (e) {}
    return v;
  })());

  // A real click on the size selector means the visitor has taken over — drop
  // the pending size so nothing overrides them. isTrusted keeps our own
  // synthetic events and the theme's re-renders from tripping this; the swatch
  // itself is excluded because that is the click that arms it.
  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target || !e.target.closest) return;
    if (e.target.closest('a.pdp-connected-grid__cell')) return;
    if (e.target.closest('.VariantSelect')) pending = null;
  }, true);

  function restore() {
    if (!pending) return;
    if (Date.now() > pendingUntil) { pending = null; return; }
    var inputs = sizeInputs();
    if (!inputs.length) return;
    var hit = inputs.filter(function (i) { return i.value === pending; })[0];
    if (!hit) { pending = null; return; }   // that size is not offered here
    if (hit.checked) return;                // already right — idempotent, no loop
    hit.checked = true;
    hit.dispatchEvent(new Event('change', { bubbles: true }));
    hit.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function currentVariant() {
    var m = (window.location.search || '').match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  // ---- gallery follows the chosen size -------------------------------------
  // Each size variant has its own featured image, but the theme never moves the
  // gallery when the size changes. Map variant -> featured_media -> thumb index
  // and drive the main Swiper. Guarded on the variant id changing, so a visitor
  // who browses the gallery by hand is never yanked back.
  var lastVariant = null;

  function variantData() {
    var s = [].slice.call(document.querySelectorAll('.variant-selectors script[type="application/json"]'))
      .filter(function (x) { return x.textContent.indexOf('"option1"') !== -1; })[0];
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function syncGallery() {
    var v = currentVariant();
    if (!v) return;
    if (v === lastVariant) return;
    lastVariant = v;
    var data = variantData();
    if (!data) return;
    var hit = data.filter(function (x) { return String(x.id) === v; })[0];
    if (!hit || !hit.featured_media) return;
    var idx = -1;
    [].slice.call(document.querySelectorAll('.main-product__thumb[data-media-id]'))
      .forEach(function (t, i) {
        if (t.getAttribute('data-media-id').split('-').pop() === String(hit.featured_media.id)) idx = i;
      });
    if (idx < 0) return;
    var main = document.querySelector('.mainSwiper');
    if (main && main.swiper) main.swiper.slideTo(idx);
  }

  // ---- SNR follows the chosen variant --------------------------------------
  // blocks/text.liquid renders [[snr]] as <span data-he-snr='{"variantId":"27"}'>.
  // Liquid resolves it correctly on page load, but the theme does not re-render
  // the section on a variant change, so update the text here. Idempotent.
  function syncSnr() {
    var nodes = document.querySelectorAll('[data-he-snr]');
    if (!nodes.length) return;
    var v = currentVariant();
    if (!v) return;
    [].slice.call(nodes).forEach(function (el) {
      var map;
      try { map = JSON.parse(el.getAttribute('data-he-snr') || '{}'); } catch (e) { return; }
      var val = map[v];
      if (val === undefined || val === null) return;
      if (el.textContent !== String(val)) el.textContent = String(val);
    });
  }

  // ---- breadcrumb follows the product --------------------------------------
  // The breadcrumb is rendered in the layout, outside the section the theme swaps,
  // so the last crumb would keep the previous product name after a colour change.
  // The BreadcrumbList JSON-LD is left alone — crawlers load each URL fresh.
  function syncCrumb() {
    var el = document.querySelector('[data-breadcrumb-current]');
    if (!el) return;
    var h1 = document.querySelector('product-component h1, .main-product h1');
    if (!h1) return;
    var name = (h1.textContent || '').replace(/\s+/g, ' ').trim();
    if (!name) return;
    if (el.textContent.replace(/\s+/g, ' ').trim() !== name) el.textContent = name;
  }

  // ---- colours: 4 across on mobile, no "+ more" collapse -------------------
  // Under 1025px the connected-colour grid is 3 across and the theme's bundled
  // script clamps it to a single row, moving the overflow behind a "+ more (N)"
  // button. Liquid already renders every colour into the page, so the fix is:
  //   a) widen the mobile grid to 4 columns (5 colours -> 2 rows, 7 -> 2 rows),
  //   b) force every colour cell visible,
  //   c) hide the "+ more" / "- close" toggle.
  // (a) and (b) are CSS with !important so they beat anything the bundle sets
  // inline. (c) needs JS: the toggle is injected at runtime with no stable
  // class, so it is found by matching the label templates the component itself
  // carries, then flagged with data-he-hidden. Flagging is idempotent, so the
  // observer cannot loop on it.
  var STYLE_ID = 'he-connected-colours';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    if (!document.head) return;
    var css = [
      '@media (max-width: 1024px) {',
      '  .pdp-connected-grid--colors {',
      '    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;',
      '    max-height: none !important;',
      '  }',
      '  .pdp-connected-grid--colors [data-connected-color-cell] {',
      '    display: flex !important;',
      '    visibility: visible !important;',
      '  }',
      '  .pdp-connected-grid--colors [data-connected-color-cell]:not(:nth-child(3n + 1 of [data-connected-color-cell])) { margin-left: 0; }',
      '  .pdp-connected-grid--colors [data-connected-color-cell]:nth-child(n + 4 of [data-connected-color-cell]) { margin-top: 0; }',
      '  .pdp-connected-grid--colors [data-connected-color-cell]:not(:nth-child(4n + 1 of [data-connected-color-cell])) { margin-left: -1px; }',
      '  .pdp-connected-grid--colors [data-connected-color-cell]:nth-child(n + 5 of [data-connected-color-cell]) { margin-top: -1px; }',
      '}',
      '[data-he-hidden] { display: none !important; }'
    ].join('\n');
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = css;
    document.head.appendChild(el);
  }

  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function toggleMatcher(comp) {
    var more = comp.getAttribute('data-connected-products-show-more-template') || '+ more (COUNT)';
    var close = comp.getAttribute('data-connected-products-close-label') || '- close';
    return new RegExp('^(' + escapeRe(more).replace('COUNT', '\\d+') + '|' + escapeRe(close) + ')$');
  }

  function unclamp() {
    var comps = document.querySelectorAll('[data-connected-products-type="colors"]');
    if (!comps.length) return;
    [].slice.call(comps).forEach(function (comp) {
      var grid = comp.querySelector('.pdp-connected-grid');
      var re = toggleMatcher(comp);
      [].slice.call(comp.querySelectorAll('*')).forEach(function (el) {
        if (el.hasAttribute('data-connected-color-cell')) return;
        if (el.querySelector('*')) return;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t || !re.test(t)) return;
        var target = el;
        if (grid && grid.contains(el)) {
          var node = el;
          while (node.parentElement && node.parentElement !== grid) node = node.parentElement;
          if (node.parentElement === grid) target = node;
        }
        if (target.querySelector('[data-connected-color-cell]')) return;
        if (!target.hasAttribute('data-he-hidden')) target.setAttribute('data-he-hidden', '');
      });
    });
  }

  function apply() { injectStyles(); reorder(); restore(); syncGallery(); syncSnr(); syncCrumb(); unclamp(); }

  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; apply(); }, 60);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || !t.closest) return;
    var a = t.closest('a.pdp-connected-grid__cell');
    if (!a) return;
    var v = chosenSize();
    if (!v) return;
    arm(v);                                             // the AJAX path
    try { sessionStorage.setItem('he-size', v); } catch (err) {}   // the page-load path
    a.href = a.href.split('#')[0] + '#' + KEY + encodeURIComponent(v);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    if (t.classList.contains('inputSelectboxCheckbox')) schedule();
    else if (t.type === 'radio' || t.tagName === 'SELECT') schedule();
  }, true);

  document.addEventListener('click', function () { schedule(); }, true);

  window.addEventListener('popstate', schedule);
  window.addEventListener('hashchange', schedule);

  function start() {
    apply();
    if (window.MutationObserver && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();